var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAntDesignUploadOutlined = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2952 23.2688H34.7078V48.0466C34.7078 48.3689 34.9714 48.6325 35.2937 48.6325H39.6882C40.0105 48.6325 40.2742 48.3689 40.2742 48.0466V23.2688H45.7014C46.1921 23.2688 46.4631 22.7048 46.1628 22.3239L37.9597 11.9382C37.9049 11.8682 37.8349 11.8115 37.7549 11.7726C37.675 11.7336 37.5872 11.7134 37.4983 11.7134C37.4094 11.7134 37.3216 11.7336 37.2416 11.7726C37.1617 11.8115 37.0917 11.8682 37.0369 11.9382L28.8337 22.3166C28.5334 22.7048 28.8044 23.2688 29.2952 23.2688ZM64.3049 45.8493H59.9104C59.5881 45.8493 59.3245 46.113 59.3245 46.4353V57.7146H15.6721V46.4353C15.6721 46.113 15.4084 45.8493 15.0862 45.8493H10.6917C10.3694 45.8493 10.1057 46.113 10.1057 46.4353V60.9372C10.1057 62.2336 11.1531 63.281 12.4495 63.281H62.5471C63.8435 63.281 64.8909 62.2336 64.8909 60.9372V46.4353C64.8909 46.113 64.6272 45.8493 64.3049 45.8493Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAntDesignUploadOutlined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ant-design_upload-outlined.e97e6d98442be2a2cf96d90d8799fd01.svg";